import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/langTabOption'

export const langTabOptionService = {
    search,
    getItem,
    saveItem,
    saveAll,
    updateItem,
    updateAll,
    syncFirebase
};

function search(data) {
    return utilHelper.doRequest(`${relativeUrl}/search`, 'POST', data)
}

function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET')
}

function syncFirebase() {
    return utilHelper.doRequest(`${relativeUrl}/syncFirebase`, 'GET')
}

function saveAll(data) {
    return utilHelper.doRequest(`${relativeUrl}/saveAll`, 'POST', data);
}

function saveItem(data) {
    return utilHelper.doRequest(`${relativeUrl}`, 'POST', data);
}

function updateItem(id, data) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'PUT', data);
}

function updateAll(data) {
    return utilHelper.doRequest(`${relativeUrl}/updateAll`, 'POST', data);
}